/**
 * Filters known third-party / framework deprecation noise from console so it
 * does not dominate DevTools or PostHog session-replay console capture.
 * Real app errors still pass through.
 */

const SILENCED = [
  /findDOMNode is deprecated/i,
  /forwardRef render functions accept exactly two parameters/i,
  /\[antd:/i,
  /ResizeObserver loop/i,
  /Download the React DevTools/i,
];

function shouldSilence(args) {
  const text = args
    .map((a) => {
      if (typeof a === "string") return a;
      if (a instanceof Error) return `${a.name}: ${a.message}`;
      try {
        return String(a);
      } catch {
        return "";
      }
    })
    .join(" ");
  return SILENCED.some((re) => re.test(text));
}

let installed = false;

export function silenceKnownConsoleNoise() {
  if (installed || typeof console === "undefined") return;
  installed = true;

  const wrap = (method) => {
    const original = console[method]?.bind(console);
    if (!original) return;
    console[method] = (...args) => {
      if (shouldSilence(args)) return;
      original(...args);
    };
  };

  wrap("warn");
  wrap("error");
}
